// extracted by mini-css-extract-plugin
module.exports = {"cameraBtn":"cameraBtn___3vEGi","on":"on___11X2f","disable":"disable___p9eU0","icon":"icon___yq7LE","not-available":"not-available___2usR-","warn":"warn___4frS8"};